import React, { useState } from 'react';
import axios from 'axios';
import {
  FaTimes, FaSearch, FaCheckCircle, FaClock,
  FaTimesCircle, FaInfoCircle, FaCalendarAlt,
  FaMapMarkerAlt, FaUserFriends, FaEnvelope
} from 'react-icons/fa';
import './TrackModal.css';

/* Status → color + icon */
const STATUS_META = {
  pending:   { color: '#f5a623', label: 'Pending',   icon: <FaClock /> },
  confirmed: { color: '#0074D9', label: 'Confirmed', icon: <FaInfoCircle /> },
  completed: { color: '#0a5c36', label: 'Completed', icon: <FaCheckCircle /> },
  cancelled: { color: '#d0021b', label: 'Cancelled', icon: <FaTimesCircle /> }
};

function TrackModal({ onClose }) {
  const [mode, setMode] = useState('number');
  const [value, setValue] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!value.trim()) return;
    setLoading(true);
    setSearched(true);
    try {
      const params = mode === 'number'
        ? { request_number: value.trim() }
        : { email: value.trim() };
      const r = await axios.get('https://api.hospifylink.com/api/requests/track', { params });
      setResults(r.data);
    } catch {
      setResults([]);
    }
    setLoading(false);
  };

  const getStatus = (s) => STATUS_META[s] || {
    color: '#999', label: s || 'Unknown', icon: <FaInfoCircle />
  };

  return (
    <div className="trackmodal-root" onClick={onClose}>
      <div className="trackmodal-box" onClick={e => e.stopPropagation()}>
        <button className="trackmodal-close" onClick={onClose}><FaTimes /></button>

        <div className="trackmodal-scroll">
          <h2>Track Your Request</h2>
          <p>Enter your request number or email to see the status.</p>

          <div className="trackmodal-tabs">
            <button
              type="button"
              className={mode === 'number' ? 'trackmodal-tab-active' : ''}
              onClick={() => setMode('number')}
            >
              By Number
            </button>
            <button
              type="button"
              className={mode === 'email' ? 'trackmodal-tab-active' : ''}
              onClick={() => setMode('email')}
            >
              By Email
            </button>
          </div>

          <form className="trackmodal-form" onSubmit={submit}>
            <input
              value={value}
              onChange={e => setValue(e.target.value)}
              placeholder={mode === 'number' ? 'HL-XXXXXXXX' : 'you@example.com'}
              autoFocus
            />
            <button type="submit" className="lca-btn-primary" disabled={loading}>
              <FaSearch /> {loading ? 'Searching…' : 'Track'}
            </button>
          </form>

          {searched && (
            <div className="trackmodal-results">
              {results.length === 0 && !loading && (
                <p className="trackmodal-empty">
                  No requests found. Please check your input.
                </p>
              )}

              {results.map(r => {
                const meta = getStatus(r.status);
                return (
                  <div key={r.id} className="trackmodal-item">
                    <div className="trackmodal-item-head">
                      <span className="trackmodal-num">{r.request_number}</span>
                      <span
                        className="trackmodal-status"
                        style={{ background: meta.color }}
                      >
                        {meta.icon} {meta.label}
                      </span>
                    </div>

                    <div className="trackmodal-item-body">
                      <p>
                        <b>Service:</b> {r.service_type || '-'}
                        {r.number_of_professionals
                          ? ` — ${r.number_of_professionals} requested`
                          : ''}
                      </p>
                      <p>
                        <FaCalendarAlt className="trackmodal-icon" />
                        <b>Event:</b> {r.event_type || '-'}
                        {'  ·  '}
                        {r.event_date ? new Date(r.event_date).toLocaleDateString() : '-'}
                        {r.event_time ? ` ${r.event_time.slice(0, 5)}` : ''}
                      </p>
                      <p>
                        <FaUserFriends className="trackmodal-icon" />
                        <b>Guests:</b> {r.guests || '-'}
                      </p>
                      <p>
                        <FaMapMarkerAlt className="trackmodal-icon" />
                        <b>Location:</b> {r.location || '-'}
                      </p>
                      {r.phone && (
                        <p>
                          <FaEnvelope className="trackmodal-icon" />
                          <b>Contact:</b> {r.phone}
                        </p>
                      )}
                      <p className="trackmodal-created">
                        <b>Submitted:</b> {new Date(r.created_at).toLocaleString()}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TrackModal;
